import { Pipe, PipeTransform } from '@angular/core';
import { Dictionary } from '@ngrx/entity';
import { TagData } from '../../../../globals/store/tags.data';
import { Entity } from 'globals/store/entity.data';

@Pipe({
    name: 'idsToTagData',
    standalone: true
})
export class IdsToTagDataPipe implements PipeTransform {
  transform<T extends { id: string, title: string }>(ids: string[], itemMap: Dictionary<T>, untitledTitle = 'Untitled Session'): TagData[] {
    return (ids || []).map(id => itemMap[id]).filter(s => !!s).map(s => ({ id: s.id, title: s.title || untitledTitle }))
  }
}

@Pipe({
    name: 'entityIdsToTagData',
    standalone: true
})
export class EntityIdsToTagDataPipe implements PipeTransform {
  transform(ids: string[], itemMap: Dictionary<Entity & { photoUrl?: string }>, untitledTitle = 'Attendee'): TagData[] {
    return (ids || []).map(id => itemMap[id]).filter(s => !!s).map(s => ({ id: s.id, title: s.name || untitledTitle, photoURL: s.photoUrl }))
  }
}